<!--
 * @Author: DESKTOP-ROEB53E\caiyangjie 1760178806@qq.com
 * @Date: 2024-01-18 11:29:29
 * @LastEditors: DESKTOP-ROEB53E\caiyangjie 1760178806@qq.com
 * @LastEditTime: 2024-02-22 15:16:50
 * @FilePath: \合联\oms\src\view\analysis\tmTrackWarning\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    :footer="footer"
    ref="table"
  >
  </cTable>
</template>

<script>
import cTable from "@/base/common/index";
import { apis } from "@/api/analysis/tmTrackWarning";
export default {
  name: "tmTrackWarning",
  components: {
    cTable
  },
  data() {
    return {
      methods: {
        ...apis
      },
      config: {},
      footer: {},
      modals: {},
      header: {
        searchs: [
          {
            key: "client_id",
            placeholder() {
              return this.$tz("客户");
            },
            component: "Select",
            options: [],
            optionsFn: "customer",
            optionsKey: ""
          },
          {
            key: "country",
            placeholder() {
              return this.$tz("国家");
            },
            component: "Select",
            options: [],
            optionsFn: "toCountry",
            optionsKey: ""
          },
          {
            key: "status",
            placeholder() {
              return this.$tz("轨迹");
            },
            component: "Select",
            options: [],
            optionsFn: "getTrackerStatus",
            optionsKey: ""
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              autosize: { minRows: 2, maxRows: 2 }
            }
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$tz("导出"),
              type: "export",
              fnName: "export",
              bind: {
                type: "primary"
              },
              disabled() {
                return this.selectAll.length === 0;
              }
            }
          ],
          methods: {
            export() {
              this.exportExc();
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          width: 50,
          fixed: "left",
          align: "center"
        },
        {
          name: () => this.$tz("运单号"),
          key: "airway_number",
          minWidth: 130,
          header: {
            copy: true
          },
          copy: true
        },
        {
          name: () => this.$tz("国家"),
          key: "country",
          minWidth: 110
        },
        {
          name: () => this.$tz("客户"),
          key: "client",
          minWidth: 130
        },
        {
          name: () => this.$tz("轨迹代码"),
          key: "status",
          minWidth: 130
        },
        {
          name: () => this.$tz("轨迹时间"),
          key: "status_time",
          minWidth: 130
        }
      ]
    };
  }
};
</script>

<style scoped></style>
